import { DataTableHeader } from "vuetify";

export const changeSetHeaders: DataTableHeader[] = [
  {
    text: "Created",
    value: "createdAt",
    width: "6rem"
  },
  {
    text: "User",
    value: "userName",
    width: "6rem"
  },
  {
    text: "Description",
    value: "description",
    width: "12rem"
  },
  {
    text: "Num Changes",
    value: "numChanges",
    width: "6.75rem"
  },
  {
    text: "Effective Date",
    value: "effectiveDate",
    width: "6.75rem"
  },
  {
    text: "Last Updated",
    value: "updatedAt",
    width: "6.75rem"
  },
  {
    text: "Status",
    value: "status",
    width: "14rem"
  },
  {
    text: "Actions",
    value: "actions",
    sortable: false,
    width: "18rem",
    class: "pl-6"
  },
  {
    text: "",
    value: "refresh",
    sortable: false,
    width: "0.25rem"
  }
];
